import { Component, OnInit } from '@angular/core';
import { SwaggerUIBundle } from 'swagger-ui-dist';
import { DataService } from '../shared/services/data-service/data.service';
import { environment as env } from 'src/environments/environment';
import { UserService } from '../shared/services/user-service/user.service';

@Component({
  standalone: false,
  selector: 'app-api-document',
  templateUrl: './api-document.component.html',
  styleUrls: ['./api-document.component.scss'],
})
export class ApiDocumentComponent implements OnInit {
  constructor(
    private dataService: DataService,
    private userService: UserService
  ) {}

  async ngOnInit(): Promise<void> {
    var accessToken = await this.userService.getAccessToken();

    const ui = SwaggerUIBundle({
      dom_id: '#swagger-ui',
      layout: 'BaseLayout',
      presets: [
        SwaggerUIBundle.presets.apis,
        SwaggerUIBundle.SwaggerUIStandalonePreset,
      ],
      url: `${env.base_api_swagger}`,
      docExpansion: 'none',
      requestInterceptor: (req) => {
        req.headers['Authorization'] = `Bearer ${accessToken}`;
        return req;
      },
    });
  }
}

